<template>
    <b-card :class="{'shadow':true, 'panel-fullscreen': fullScreen}">
        <template v-slot:header>
            <p class="text-primary font-weight-bold mb-0 card-header__title">{{ title }}</p>
            <div class="card-header__actions">
                <b-dropdown variant="outline-secondary" class="mr-2 card-header__actions__dropdown" no-caret>
                    <template v-slot:button-content>
                        <i class="fas fa-ellipsis-v"/>
                    </template>
                    <b-dropdown-item @click="$emit('maximize')">
                        {{ fullScreen ? $t('dashboard.cards.minimizar') : $t('dashboard.cards.maximizar') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="$emit('close')">
                        {{ $t('dashboard.cards.fechar') }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </template>
        <b-card-text>
            <slot />
        </b-card-text>
    </b-card>
</template>

<script>
    export default {
        name: "CardCloseMaximize",
        props: {
            fullScreen: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: null
            }
        }
    }
</script>

<style lang="scss" scoped>
    .panel-fullscreen {
        display: block !important;
        z-index: 1000 !important;
        position: fixed !important;
        width: 100% !important;
        height: 100% !important;
        top: 0 !important;
        right: 0 !important;
        left: 0 !important;
        bottom: 0 !important;
        overflow: auto !important;
        margin-left: 0px !important;
        margin-right: 0px !important;
    }

    .card-header {
        display: flex;
        justify-content: flex-start;
        flex-direction: row;

        &__ {
            &title {
                flex: 1;
            }

            &actions {
                cursor: pointer;

                &__ {
                    &dropdown {
                        /deep/ button {
                            border: none;
                            padding: 0 5px;
                        }
                    }
                }
            }
        }
    }
</style>